import { Component, OnInit } from '@angular/core';
import { DateService } from '../services/date.service';
import { Router } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute } from '@angular/router';
import { ActionsService } from '../services/actions.service';
import * as globalUrls from '../services/globalVariables';

@Component({
  selector: 'app-planning-collaborateur',
  templateUrl: './planning-collaborateur.component.html',
  styleUrls: ['./planning-collaborateur.component.scss'],
})
export class PlanningCollaborateurComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public route: ActivatedRoute,
    public actionsService: ActionsService,
    public dateServise: DateService,
    public router: Router
  ) {}

  urlSelectPerso = globalUrls.urlSelectPerso;
  listeCollaborateurs;
  collaborateur;
  listWeek;
  listMonth;
  listYear;
  date_Debut;
  date_Fin;
  disabled;
  showCalendar = false;
  listeActionD;
  //listeAction;
  events = [];
  expanded = true;
  intervale;
  defaultDate;
  listeClients = null;
  listeColl;
  date;
  ngOnInit() {
    this.readParamUrl();
  }
  init() {
    this.generalService
      .rechercheTable(globalUrls.urlListClientFull)
      .subscribe((data) => {
        this.listeClients = data;
      });
    this.generalService
      .rechercheTable(this.urlSelectPerso)
      .subscribe((data) => {
        this.listeCollaborateurs = this.generalService.sort(
          data.filter((c) => {
            return c.Perso_TypePerso != '2' && c.Perso_TypePerso != '10';
          }),
          'NomPrenom'
        );
        this.date_Debut = new Date();
        this.date_Debut.setMonth(this.date_Debut.getMonth() - 2);
        this.date_Debut.setDate(1);
        this.date_Fin = new Date();
        this.date_Fin.setMonth(this.date_Fin.getMonth() + 2);
        this.date_Fin.setDate(1);
        if (this.date != '1' && this.intervale != '1') {
          this.afficherDate();
          this.showDetaille(this.date, this.intervale);
        }
      });
  }
  async afficherDate() {
    if (this.collaborateur != undefined) {
      this.listeActionD = await this.generalService
        .rechercheTable(
          globalUrls.urlListeActionActionDColl +
            this.dateServise.setFormatDateRechercheServer(this.date_Debut) +
            ',' +
            this.dateServise.setFormatDateRechercheServer(this.date_Fin) +
            ',' +
            this.collaborateur
        )
        .toPromise();
      this.listWeek = this.dateServise.getListWeek(
        this.date_Debut,
        this.date_Fin
      );
      this.listMonth = this.dateServise.getListMonth(
        this.date_Debut,
        this.date_Fin,
        0
      );
      this.actionsService.enableDesableBouton(
        this.listWeek,
        this.listMonth,
        this.listeActionD
      );
    } else
      this.generalService.dialogSuccess('veuillez choisir un client', false);
  }
  async showDetaille(date, intervale) {
    if (
      this.date_Debut != null &&
      this.date_Fin != null &&
      this.date_Debut <= this.date_Fin &&
      this.collaborateur != undefined &&
      this.listeClients != null
    ) {
      if (this.listeClients != null) {
        this.showCalendar = false;
        this.defaultDate = this.dateServise.convertStrToDate(date);
        this.expanded = true;
        // this.intervale = intervale;
        this.events = [];
        this.listeActionD = await this.generalService
          .rechercheTable(
            globalUrls.urlListeActionActionDColl +
              this.dateServise.setFormatDateRechercheServer(this.date_Debut) +
              ',' +
              this.dateServise.setFormatDateRechercheServer(this.date_Fin) +
              ',' +
              this.collaborateur
          )
          .toPromise();
        if (this.listeActionD.length > 0) {
          //var listeCodeListeActionD=this.generalService.distinct(this.listeActionD,"avtActionD_Code").reduce((accumulator, currentValue) => accumulator+";" + currentValue);
          //this.listeAction= await this.generalService.rechercheTable(this.generalService.urlListeActionLAD+listeCodeListeActionD).toPromise();
          this.events = this.actionsService.setCalendar2(
            this.listeActionD,
            this.events,
            this.listeClients,
            this.listeCollaborateurs,
            'coll'
          );
          this.showCalendar = true;
        } else {
          this.generalService.dialogSuccess('Aucune action à afficher', false);
        }
      } else {
        this.generalService.dialogSuccess(
          "SVP veuillez patienter jusqu'à le chargement total des données",
          true
        );
      }
    } else {
      this.generalService.dialogSuccess(
        'SVP veuillez SVP remplir le formulaire ci-dessous',
        false
      );
    }
  }
  eventRender(event) {
    event.event.el.querySelector('.fc-title').innerHTML =
      event.event.event.title;
  }
  actionCalendar(event) {
    switch (event.acton) {
      case 'eventRender':
        this.eventRender(event);
        break;
    }
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.date = params['date'];
      this.intervale = params['intervale'];
      if (params['param_code'] != '-1')
        this.collaborateur = params['param_code'];
      this.init();
    });
  }
}
